import { useContext } from "react"

import DashboardContext from "../../../Context"
import CreateCancel from "../../../components/forms/CreateCancel"
import Tabel from "../../../components/tabel/Tabel"
import FormPartnerCompany from "./FormPartnerCompany"

export default function PartnerCompany() {

    const { SohwaddFrom } = useContext(DashboardContext)

    return (
        <>
            <CreateCancel />
            {
                SohwaddFrom ?
                    <div style={{ backgroundColor: 'white', padding: '20px', borderRadius: '15px' }} >

                        <FormPartnerCompany />
                    </div>
                    :
                    <Tabel />
            }
        </>
    )
}